import * as actions from './actions';
import { ActionType, createReducer } from 'typesafe-actions';
import { ACTION_STATUSES } from 'shared/consts';
import { CollectionsState } from './types';

export const initialState: CollectionsState = {
  collections: null,
  loading: false,
  error: null,
  getCollections: {
    status: null,
    error: null,
  },
};

const getResourceCollectionsRequestHandler = (state: CollectionsState) => ({
  ...state,
  loading: true,
  getCollections: {
    status: ACTION_STATUSES.PENDING,
  },
});

const getResourceCollectionsSuccessHandler = (
  state: CollectionsState,
  { payload }: ActionType<typeof actions.getResourceCollections.success>,
): CollectionsState => ({
  ...state,
  collections: payload.collections,
  loading: false,
  error: null,
  getCollections: {
    status: ACTION_STATUSES.FULFILLED,
    error: null,
  },
});

const getResourceCollectionsFailureHandler = (
  state: CollectionsState,
  { payload: error }: ActionType<typeof actions.getResourceCollections.failure>,
): CollectionsState => ({
  ...state,
  loading: false,
  error: error.error,
  getCollections: {
    status: ACTION_STATUSES.REJECTED,
    error: error.error,
  },
});

const resetResourceCollectionsStateHandler = (state: CollectionsState): CollectionsState => ({
  ...state,
  collections: null,
  loading: false,
  error: null,
  getCollections: {
    status: null,
    error: null,
  },
});

const collectionsReducer = createReducer(initialState)
  .handleAction(actions.getResourceCollections.request, getResourceCollectionsRequestHandler)
  .handleAction(actions.getResourceCollections.success, getResourceCollectionsSuccessHandler)
  .handleAction(actions.getResourceCollections.failure, getResourceCollectionsFailureHandler)
  .handleAction(actions.resetResourceCollectionsState, resetResourceCollectionsStateHandler);

export default collectionsReducer;
